const aboutData= [
    {
        year:'2021-2025',
        dept:'Electronics and Communication Engineering',
        school:'Kongu Engineering College',
        description:'Delving into the foundational aspects of the feild',
        Scored:'CGPA: 7.74*'
        
    },

    {
        year:'2019-2021',
        dept:'Higher Secondary(HSC)',
        school:'Gnanasambandar Matric hr sec school',
        description:'Subjects: Maths, Physics, Chemistry, Biology, Tamil, English',
        Scored:': 89.7%'
    },
    {
        year:'2018-2019',
        dept:'Secondary(SSLC)',
        school:'Gnanasambandar Matric hr sec school',
        description:'Subjects: Maths, Science, Social, English, Tamil',
        Scored:': 87.7%'
    },


];
export default aboutData;
